<template>
	<div>
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="准进设备查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">MAC：</div>
						<a-input v-model="query.mac" style="width: 100%;" placeholder="请输入设备mac" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiCheckDeviceQueryListByMac">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :columns="tableColumns" :data-source="tableData" row-key="checkdeviceId" :loading="tableLoading" :pagination="false">

				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="edit(tableAction)">绑定设备</a-button>
				</span>
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="editRules">
				<a-form-model-item label="设备名称" has-feedback prop="checkdeviceName">
					<a-input v-model="editForm.checkdeviceName" placeholder="请输入设备名称" />
				</a-form-model-item>
				<a-form-model-item label="所属服务商" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" placeholder="请选择服务商"  @change="editSelectFacilitator" >
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="所属园门" has-feedback prop="checkstationId">
					<a-select v-model="editForm.checkstationId" placeholder="请选择园门" >
						<a-select-option v-for="(item,index) in checkstation" :value="item.checkstationId" :key="index">{{item.checkstationName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="MAC地址" has-feedback prop="mac">
					<a-input v-model="editForm.mac" placeholder="请输入MAC地址" disabled/>
				</a-form-model-item>
				<a-form-model-item label="设备位置" has-feedback prop="enterOut">
					<a-radio-group name="enterOut" v-model="editForm.enterOut">
						<a-radio :value="1">入口设备</a-radio>
						<a-radio :value="0">出口设备</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="第三方设备编号" has-feedback prop="strTESn">
					<a-input v-model="editForm.strTESn" placeholder="请输入第三方设备编号" />
				</a-form-model-item>
				<a-form-model-item label="阶梯分账账户" has-feedback prop="ladderAccount">
					<a-input v-model="editForm.ladderAccount" placeholder="请输入阶梯分账账户" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="checkdeviceState">
					<a-radio-group name="checkdeviceState" v-model="editForm.checkdeviceState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				//服务商列表
				facilitatorList: [],
				//园门列表
				checkstation: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
					checkdeviceName: '',
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'checkdeviceId', key:'checkdeviceId', align:'center'},
					{ title:'MAC地址', key:'tel', dataIndex:'mac',align:'center'},
					{ title: '操作', key: 'tableAction', align: 'center', scopedSlots: { customRender: 'tableAction' } },
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				editRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					checkstationId: [{ required: true, message: '请选择园门', trigger: 'blur' }],
					checkdeviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					checkdeviceId: '',
					checkdeviceName: '',
					facilitatorId: undefined,
					checkstationId: undefined,
					mac: '',
					enterOut:1,
					strTESn:'',
					ladderAccount:'',
					checkdeviceState: 3,
					remarks: '',
				},
				// 修改弹窗-end
				
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取园门列表
			async apiCheckstationList(id) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationList,{'facilitatorId':id});
				if (res.code == 200) {
					this.checkstation = res.data
				} else {
					this.$message.error(res.msg)
				}
			},

			//表格开始-搜索
			async apiCheckDeviceQueryListByMac() {
				this.tableLoading = true
	
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceQueryListByMac, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiCheckDeviceQueryListByMac()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiCheckDeviceQueryListByMac()
			},
	
			//修改弹窗事件-开始
			edit(item){
				this.editForm = item
                if(this.editForm.facilitatorId == 0){
                    this.editForm.facilitatorId = undefined
                }
                if(this.editForm.checkstationId == 0){
                    this.editForm.checkstationId = undefined
                }
				this.apiCheckstationList(item.checkstationId)
				this.editVisible = true
			},
			editSelectFacilitator(e){
				this.editForm.checkstationId = undefined
				this.apiCheckstationList(e)
			},
			async apiCheckDeviceEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiCheckDeviceQueryListByMac()
                    this.$emit('success');
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiCheckDeviceEdit()
					} else {
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
		},
		computed: {
		},
		created() {
			this.apiFacilitatorList()
            this.apiCheckDeviceQueryListByMac()
		}
	};
</script>

<style scoped>
	
</style>
